import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
@Component({
  selector: 'mtls-priceless-button',
  templateUrl: './mtls-priceless-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatButtonModule],
})
/*
Pricless SDK script is found here: append-mtls-priceless-donate-widget.ts

usage:
<mtls-priceless-button text='Yo click me'></mtls-priceless-button>
*/
export class MtlsPricelessButtonComponent {
  @Input() public text: string;

  public hasScriptAppended(): boolean {
    return !!window['loadWidgetSDK'];
  }

  public loadWidget() {
    window['loadWidgetSDK']();
  }
}
